import React from 'react';
import { HomePagePresentation } from './HomePagePresentation';
import { useNavigate } from 'react-router-dom';
import { Header } from './Header';
import { Hero } from './Hero';
import { HowItWorks } from './HowItWorks';
import { Features } from './Features';
import { Testimonials } from './Testimonials';
import { Pricing } from './Pricing';
import { Footer } from './Footer';

/** Landing page that assembles all marketing sections (Hero, Features, Gallery, etc.). */
export const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const presentationRoot = React.useRef<HTMLDivElement>(null);

  const navigateToPrivacy = () => navigate('/privacy');
  const navigateToTerms = () => navigate('/terms');
  const navigateToLogin = () => navigate('/login');

  return (
    <div className="App homepage-presentation" ref={presentationRoot}>
      <HomePagePresentation root={presentationRoot} />
      <Header onNavigateToLogin={navigateToLogin} />
      <main>
        <Hero onNavigateToLogin={navigateToLogin} />
        <HowItWorks />
        <Features />
        <Testimonials />
        <Pricing />
      </main>
      <Footer
        onNavigateToPrivacy={navigateToPrivacy}
        onNavigateToTerms={navigateToTerms}
      />
    </div>
  );
};

export default HomePage;
